import { render } from "./Instagram.vue?vue&type=template&id=d18d30d6"
import script from "./Instagram.vue?vue&type=script&lang=js"
export * from "./Instagram.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__